import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useLocation } from 'react-router-dom';
import Navigation from './Navigation';
import HeroSection from './HeroSection';
import TrustStrip from './TrustStrip';
import ProblemSection from './ProblemSection';
import HowItWorks from './HowItWorks';
import FeatureBlocks from './FeatureBlocks';
import RecruiterWorkflow from './RecruiterWorkflow';
import CandidateExperience from './CandidateExperience';
import AIInterviewSection from './AIInterviewSection';
import ProductScreens from './ProductScreens';
import PricingSection from './PricingSection';
import CustomerStories from './CustomerStories';
import SecuritySection from './SecuritySection';
import FAQSection from './FAQSection';
import FinalCTA from './FinalCTA';
import Footer from './Footer';
import BookPilotModal from './BookPilotModal';
import DemoVideoModal from './DemoVideoModal';
import ChatSupport from './ChatSupport';

const LandingPage = () => {
  const [showBookPilot, setShowBookPilot] = useState(false);
  const [showDemoVideo, setShowDemoVideo] = useState(false);

  function ScrollToHash() {
  const location = useLocation();
 
  useEffect(() => {
    if (!location.hash) return;
 
    const id = location.hash.substring(1);
 
    let retryCount = 0;
 
    const interval = setInterval(() => {
      const el = document.getElementById(id);
 
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        clearInterval(interval);
      }
 
      retryCount++;
 
      // Stop trying after 100 attempts (10 seconds total)
      if (retryCount > 100) {
        clearInterval(interval);
      }
 
    }, 100);
 
    return () => clearInterval(interval);
  }, [location]);
 
  return null;
}

  return (
    <div className="min-h-screen bg-white">
      <Navigation onBookPilot={() => setShowBookPilot(true)} />

      <main>
        <HeroSection
          onBookPilot={() => setShowBookPilot(true)}
          onDemoVideo={() => setShowDemoVideo(true)}
        />

        <ProblemSection />

        {/* HOW IT WORKS */}
        <section id="how-it-works">
          <HowItWorks />
        </section>

        {/* FEATURES */}
        <section id="features">
          <FeatureBlocks />
        </section>

        {/* RECRUITER WORKFLOW */}
        <section id="recruiter-workflow">
          <RecruiterWorkflow />
        </section>

        <CandidateExperience />
        <AIInterviewSection />
        <ProductScreens />

        <CustomerStories />
        <SecuritySection />
        <FAQSection />

        <FinalCTA onBookPilot={() => setShowBookPilot(true)} />
      </main>

      <Footer />
      <ChatSupport />

      {showBookPilot && (
        <BookPilotModal onClose={() => setShowBookPilot(false)} />
      )}

      {showDemoVideo && (
        <DemoVideoModal onClose={() => setShowDemoVideo(false)} />
      )}
    </div>
  );
};

export default LandingPage;